import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false
//引入路由
import router from './router'

// router.beforeEach((to, from, next) => {
//   /* 路由发生变化修改页面title */
//   if (to.meta.title) {
//     document.title = to.meta.title
//   }
//   next()
// })
import './assets/css/base.css'
import './assets/iconfont/iconfont.css'
//引入vuex
import store from "./store/index"
// 在main.js中引入axios
// const axios = require("axios");
// Vue.prototype.$axios = axios;
// import 'element-ui/lib/theme-chalk/index.css' //引入样式，这里是引入全部样式，你也可以单独引入某个组件样式
import { Icon } from 'element-ui';

import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts

// Vue.config.productionTip = false
Vue.use(Icon)
new Vue({
  render: h => h(App),
  //这里使用router之后，组件身上都有$router,$route属性
  //$router最常用来跳转push跳转  $route最常用来获取参数
  router,
  store,
}).$mount('#app')

document.title = '智能知识库';
